import { $Q } from "../utils/query-selector";
import api from "../services/api";
import { stringToHTML } from "../utils/to-html";
import { updateSection } from "../components/change-image"

/**
  * Section rendering to return images of the selected variant
  * 
  * @returns {Object} - main image section
  * @returns {Object} - thumbs image section
  * 
  * @author Andres Briñez
  */

export function queryModalVariants(){
  const variantSelected = $Q('#variant-id').value;
  const handleVariant = $Q('#variant-id');

  sectionHandle(handleVariant.dataset.variant, variantSelected)
}

/**
 * Captures the HTML section of the product in question and returns the node of the images to replace
 * 
 * @param { data } handle Data element of the product to which the query will be made 
 * @param { String } variantid Id of the selected variant
 */

 async function sectionHandle(handle, variantid){
  const dataHandle = `/products/${handle}`;
  const htmlResponse = await api.shopifyVariantByUrl(dataHandle,variantid);
  const variantImage = await $Q(".main-product--product-image", stringToHTML(htmlResponse));
  const variantPrice = await $Q(".main-product__detail--price", stringToHTML(htmlResponse));
  const variantAvailable = await $Q('[name="available"]', stringToHTML(htmlResponse));
  const variantColor = await $Q(".color_variable", stringToHTML(htmlResponse));

  variantPrice.classList.add('modal-price')
  variantColor.classList.add('modalvariants--name')
  

  if ( variantImage != null ) {

    variantImage.classList.add('information-modal-wrapper__image--image-variant')

    updateSection(
      variantImage,
      variantPrice, 
      variantAvailable.value, 
      variantColor,
      '.information-modal-wrapper__image',
      '.modal-price',
      '.modal-available',
      '.modalvariants--name '
    )
  } else {
    updateSection(
      variantImage,
      variantPrice, 
      variantAvailable.value, 
      variantColor,
      '.information-modal-wrapper__image',
      '.modal-price',
      '.modal-available',
      '.modalvariants--name '
    )
  }
}

